import React from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { useSelector } from 'react-redux';
import { AUTHENTICATED_ENTRY, AUTHENTICATED_ENTRY_ADMIN } from 'configs/AppConfig'
import { SYSTEM_ROLES } from 'constants/AuthConstant';
import navigationConfig from 'configs/NavigationConfig';

const getFirstAllowedRoute = (menus, permissions = []) => {
  for (const menu of menus) {
    if (menu.submenu?.length) {
      const found = getFirstAllowedRoute(menu.submenu, permissions);
      if (found) return found;
    }
    if (menu.isGroupTitle) continue;
    if (!menu.permission || permissions.includes(menu.permission)) {
      if (menu.path) return menu.path;
    }
  }
  return null;
};

const PublicRoute = () => {
  const { token, userRoles, permissionCodes } = useSelector(state => state.auth);
  let toPath = "";

  if (userRoles.includes(SYSTEM_ROLES.OperatorAdmin)) {
    toPath = AUTHENTICATED_ENTRY_ADMIN;
  } else if (userRoles.includes(SYSTEM_ROLES.PartnerAdmin) || userRoles.includes(SYSTEM_ROLES.StoreAdmin)) {
    if (!permissionCodes?.length) return <Outlet />;
    const firstAllowedPath = getFirstAllowedRoute(navigationConfig, permissionCodes);
    toPath = firstAllowedPath || AUTHENTICATED_ENTRY;
  }

  return token ? <Navigate to={toPath} /> : <Outlet />
}

export default PublicRoute